import { useTranslation } from 'react-i18next';
import { DEFAULT_LOCALE, Locale, SUPPORTED_LOCALES } from '~app/i18n';

const stringIsLocale = (str: string): str is Locale => {
  return SUPPORTED_LOCALES.includes(str as Locale);
};

export const useLocale = (): Locale => {
  const {
    i18n: { language: locale },
  } = useTranslation();

  return stringIsLocale(locale) ? locale : DEFAULT_LOCALE;
};
